import type { Playlists } from '@studio/types';

const reorderVideos = (
  list: Playlists.Derived.PlaylistMediaItems,
  sourceIndex: number,
  destinationIndex: number
): Playlists.Derived.PlaylistMediaItems => {
  const result = Array.from(list);
  const [removed] = result.splice(sourceIndex, 1);
  result.splice(destinationIndex, 0, removed);

  return result;
};

export default reorderVideos;
